import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { AppProviders } from '@app/providers';
import { appRouter } from '@app/routes';

import { ErrorBoundary } from '@shared/components';

import { initializeAuthStore } from '@features/auth';

import '@shared/styles/globals.css';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('[boot] elemento #root não encontrado em index.html');
}

initializeAuthStore();

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <RouterProvider router={appRouter} />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
